import { MonitorPlayIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/Button';

interface FeedEmptyStateAction {
    label: string;
    onPress: () => void;
}

export interface FeedEmptyStateProps {
    title: string;
    description: string;
    action?: FeedEmptyStateAction;
}

export function FeedEmptyState({
    title,
    description,
    action,
}: FeedEmptyStateProps) {
    return (
        <div className="flex-1 flex flex-col items-center justify-center border border-grey-500 rounded-lg min-h-0">
            <div className="flex flex-col items-center gap-8">
                <div className="flex flex-col items-center gap-6">
                    <MonitorPlayIcon
                        className="size-10 text-grey-400"
                        weight="regular"
                    />
                    <div className="flex flex-col items-center gap-2 text-center max-w-[266px]">
                        <h3 className="text-lg font-medium text-grey-200">
                            {title}
                        </h3>
                        <p className="text-sm text-grey-400">{description}</p>
                    </div>
                </div>
                {action && (
                    <Button variant="secondary" onClick={action.onPress}>
                        {action.label}
                    </Button>
                )}
            </div>
        </div>
    );
}
